<div [class.pt-4]="!props.readonly" [class]="props.class" [controlRef]="formControl" [fieldConfig]="this">
  @if (field.fieldGroup.length) {
    @if (invalid$ | async; as invalid) {
      @if (suggested$ | async; as suggested) {
        <p-accordion
          expandIcon="pi pi-chevron-down"
          collapseIcon="pi pi-chevron-up"
          [multiple]="true"
          [value]="props.value"
          [dt]="props.dt?.components?.accordion"
          #accordion
        >
          @for (tab of field.fieldGroup; track tab) {
            @if (!tab.hide) {
              <p-accordion-panel [value]="$index" [dt]="props.dt?.components?.accordion?.panel">
                <p-accordion-header
                  [dt]="props.dt?.components?.header"
                  [class.text-danger]="invalid[$index]"
                  [class.text-highlight]="suggested[$index]"
                  [class.text-ai-fill]="(filledByAI$ | async)?.[$index]"
                >
                  <div class="flex items-center flex-1">
                    @if (props.formatLabel) {
                      <span>
                        {{ props.formatLabel(model, $index) }}
                      </span>
                    }

                    @if (props.formatSublabel) {
                      <span
                        class="ms-2"
                        [class.text-text-subtle-text]="invalid[$index] && !suggested[$index]"
                        [class.text-danger]="invalid[$index]"
                        [class.text-highlight]="suggested[$index]"
                        [class.text-ai-fill]="(filledByAI$ | async)?.[$index]"
                      >
                        {{ props.formatSublabel(model, $index) }}
                      </span>
                    }

                    @if (!props.readonly) {
                      <div class="row ms-auto">
                        @if (showError && formControl.errors) {
                          <p-tag
                            [dt]="props.dt?.components?.tag"
                            icon="pi pi-exclamation-triangle"
                            severity="danger"
                            [rounded]="true"
                            [pTooltip]="errors"
                          />

                          <ng-template #errors>
                            <formly-validation-message [field]="field" />
                          </ng-template>
                        }
                        @if (isOpened($index)) {
                          <new-ui-button
                            [dt]="props.dt?.components?.button"
                            icon="pi pi-trash"
                            variant="text"
                            [severity]="hoveredRemoveIndex === $index ? 'danger' : 'secondary'"
                            [label]="props.removeLabel"
                            [ariaLabel]="props.removeLabel"
                            [disabled]="!isRemoveEnabled($index)"
                            [removeBtnRef]="formControl"
                            (mouseenter)="hoveredRemoveIndex = $index"
                            (mouseleave)="hoveredRemoveIndex = -1"
                            (onClick)="handleRemove($index, $event)"
                          />
                        }
                      </div>
                    }
                  </div>
                </p-accordion-header>

                <p-accordion-content [dt]="props.dt?.components?.accordion?.content">
                  <formly-field [field]="tab" />
                </p-accordion-content>
              </p-accordion-panel>
            }
          }
        </p-accordion>
      }
    }
  } @else if (props.emptystate) {
    <ui-emptystate
      [dt]="props.dt?.components?.emptystate"
      class="py-[3%]"
      [image]="props.emptystate.image"
      [caption]="props.emptystate.caption"
      [description]="props.emptystate.description"
    />
  }

  @if (!props.readonly) {
    <div class="max-mobile:col mobile:row border-t-1 border-surface-border p-4">
      <new-ui-button
        [dt]="props.dt?.components?.button"
        class="max-mobile:*:w-full"
        icon="icon-[mi--plus-medium]"
        [label]="props.addLabel"
        [ariaLabel]="props.addLabel"
        [disabled]="!isAddEnabled"
        [addBtnRef]="formControl"
        (onClick)="handleAdd($event, props.defaultValue?.())"
      />

      @if (props.additionalLabel) {
        <new-ui-button
          [dt]="props.dt?.components?.button"
          class="max-mobile:*:w-full"
          icon="icon-[mi--plus-medium]"
          severity="secondary"
          [label]="props.additionalLabel"
          [ariaLabel]="props.additionalLabel"
          [disabled]="!isAdditionalEnabled"
          [addBtnRef]="formControl"
          (onClick)="handleAdd($event, props.additionalDefaultValue?.())"
        />
      }

      @if (uploadMenu?.length) {
        @if (uploadMenu.length > 1) {
          <new-ui-button
            [dt]="props.dt?.components?.button"
            class="max-mobile:*:w-full"
            icon="icon-[mi--document-file-upload-bottom-center]"
            severity="secondary"
            [label]="props.uploadLabel"
            (onClick)="menu.toggle($event)"
          />

          <p-menu #menu [popup]="true" [model]="uploadMenu" appendTo="body" />
        } @else {
          <new-ui-button
            [dt]="props.dt?.components?.button"
            class="max-mobile:*:w-full"
            icon="icon-[mi--document-file-upload-bottom-center]"
            severity="secondary"
            [label]="props.uploadLabel"
            (onClick)="openUploadDialog(props.uploadTypes[0])"
          />
        }
      }
    </div>
  }
</div>
